module.exports = __webpack_public_path__ + "img/mongodb.2985235d.svg";